import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const SelfReg = props => (
    <SvgIcon {...props}>
        <path
            fillRule="evenodd"
            stroke="none"
            d="M13.211 3.371c.977.92 1.51 2.384 1.426 3.918l-.004.071c-.064 1.002-.284 1.823.516 3.287a.23.23 0 01-.085.308c-.782.47-1.64.587-2.415.328a.234.234 0 00-.312.23c0 .272.186.513.452.587l2.974.833c.081.023.16.05.237.082v1.58a1.4 1.4 0 01-1.4 1.4H3.58v-1.054c0-.2.03-.394.085-.58l1.162 1.147.022.02a.646.646 0 00.433.182h1.292a.664.664 0 00.668-.662v-1.274a.636.636 0 00-.185-.433l-.022-.022-.727-.717 1.79-.502a.614.614 0 00.452-.586.233.233 0 00-.303-.221c-.457.142-1.058.194-1.838.16a.232.232 0 01-.174-.376c.554-.685.45-1.26.263-2.105l-.067-.303a8.869 8.869 0 01-.219-1.574c-.063-1.566.35-2.9 1.104-3.57.453-.403 1.01-.575 1.658-.512.866-.723 2.792-1.003 4.236.358zM1.807 12.136l1.815-1.79L6.84 13.52l.016.016c.066.07.102.144.107.245v1.265a.381.381 0 01-.37.384h-.02l-.022.001H5.289a.367.367 0 01-.248-.106l-.016-.016-3.218-3.172zm.646-2.974l.748.738-1.828 1.802-.748-.737a.392.392 0 010-.574L1.87 9.162a.406.406 0 01.582 0z"
        />
    </SvgIcon>
);

export default SelfReg;
